define('HideQuantityPricing.View', [
    'Backbone',
	'SC.Configuration',
	'QuantityPricing.Utils',
	'Profile.Model',

    'hide_quantity_pricing_view.tpl',

	'underscore'
], function ItemBadgesView(
    Backbone,
	Configuration,
	QuantityPricingUtils,
	ProfileModel,

    hide_quantity_pricing_view_tpl,

	_
) {
    'use strict';

    return Backbone.View.extend({
		isErrorView: true,
        template: hide_quantity_pricing_view_tpl
	});
});
